module.exports = __webpack_public_path__ + "static/img/4.abf322c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user/4.png
// module id = lv6V
// module chunks = 0